import { Directive } from "@angular/core";
import { historyToString, isOrderHistory, ItemHistory, OrderHistory } from "src/services/history/history.types";
import { User, userToString } from "src/services/user/user.interface";
import { UserApiService } from "src/services/user/user-api.service";
import { Driver } from "src/services/driver/driver.interface";
import { removeDuplicates } from "src/services/utils/array.utils";

export type CompleteOrderHistoryLog = OrderHistory & { fullDriver?: Driver; fullUser?: User; icon?: string };
export type CompleteHistoryLog = (ItemHistory | CompleteOrderHistoryLog) & {
  fullDriver?: Driver;
  fullUser?: User;
  icon?: string;
};

@Directive()
export abstract class BaseHistoryListComponent {
  public loading: boolean = false;
  public loaded: boolean = false;
  public historyLogs: CompleteHistoryLog[];

  protected constructor(protected readonly userService: UserApiService) {}

  public async refresh(): Promise<void> {
    await this.initData();
  }

  protected async populateUsers(userIds: string[]): Promise<void> {
    if (userIds.length === 0) {
      return;
    }

    const allUsers = await this.userService.getByIds(removeDuplicates(userIds));

    const allUsersMap = {};
    for (const user of allUsers) {
      allUsersMap[user.id] = user;
    }

    for (const log of this.historyLogs) {
      log.fullUser = allUsersMap[log.user.userId];
    }
  }

  public readonly historyToString = historyToString;
  public readonly isOrderHistory = isOrderHistory;
  public readonly userToString = userToString;

  protected abstract initData(): Promise<void>;
}
